var map = {
	"./img_0.png": 620,
	"./img_1.png": 621,
	"./img_10.png": 622,
	"./img_11.png": 623,
	"./img_2.png": 624,
	"./img_3.png": 625,
	"./img_4.png": 626,
	"./img_5.png": 627,
	"./img_6.png": 628,
	"./img_7.png": 629,
	"./img_8.png": 630,
	"./img_9.png": 631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 619;